const RECOVERY_STORAGE_KEY = 'soc-portal:chunk-load-recovery-attempted';
const RECOVERY_QUERY_PARAM = '__portal_reload';

const getErrorText = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  const parts = [
    value.name,
    value.message,
    value.reason && getErrorText(value.reason),
    value.error && getErrorText(value.error),
    value.target?.href,
    value.target?.src,
  ];
  return parts.filter(Boolean).join(' ');
};

const isChunkLoadFailure = (value) => {
  const text = getErrorText(value);
  return (
    /ChunkLoadError/i.test(text) ||
    /Loading (CSS )?chunk .+ failed/i.test(text) ||
    /css chunk .+ failed/i.test(text)
  );
};

const hasAttemptedRecovery = () => {
  try {
    return window.sessionStorage.getItem(RECOVERY_STORAGE_KEY) === 'true';
  } catch (_error) {
    return window.__portalChunkLoadRecoveryAttempted === true;
  }
};

const markRecoveryAttempted = () => {
  window.__portalChunkLoadRecoveryAttempted = true;
  try {
    window.sessionStorage.setItem(RECOVERY_STORAGE_KEY, 'true');
  } catch (_error) {}
};

const reloadWithCacheBust = () => {
  const nextUrl = new URL(window.location.href);
  nextUrl.searchParams.set(RECOVERY_QUERY_PARAM, String(Date.now()));
  window.location.replace(nextUrl.toString());
};

const recoverFromChunkLoadFailure = (event) => {
  if (typeof window === 'undefined') return;
  if (!isChunkLoadFailure(event)) return;
  if (hasAttemptedRecovery()) return;

  markRecoveryAttempted();
  if (typeof event.preventDefault === 'function') {
    event.preventDefault();
  }
  reloadWithCacheBust();
};

if (typeof window !== 'undefined') {
  window.addEventListener('error', recoverFromChunkLoadFailure);
  window.addEventListener('unhandledrejection', recoverFromChunkLoadFailure);
}

export {
  isChunkLoadFailure,
  recoverFromChunkLoadFailure,
};
